import { Link, NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { PERMISSION_KEYS } from '../config/permissions'
import { NotificationsBell } from '../components/NotificationsBell'
import { btn, cn, sidebarNavLink } from '../lib/ui'

/** Глобальная боковая панель навигации (при авторизации). */
export function Sidebar() {
  const { user, logout, can } = useAuth()
  const navigate = useNavigate()

  const showProduction =
    can(PERMISSION_KEYS.PRODUCTS_READ) || can(PERMISSION_KEYS.CONSUMABLES_READ)
  const showProductionRequests = can(PERMISSION_KEYS.PRODUCTION_REQUESTS_READ)
  const showPlanning =
    can(PERMISSION_KEYS.PRODUCTION_SCHEDULE_READ) ||
    can(PERMISSION_KEYS.PRODUCTION_REQUESTS_READ) ||
    can(PERMISSION_KEYS.TIMESHEETS_READ) ||
    can(PERMISSION_KEYS.MATERIALS_READ) ||
    can(PERMISSION_KEYS.PLANNING_KIOSK)
  const showInventory =
    can(PERMISSION_KEYS.INVENTORY_READ) || can(PERMISSION_KEYS.FINISHED_GOODS_READ)
  const showShipments = can(PERMISSION_KEYS.SHIPMENTS_READ)

  return (
    <aside
      className={cn(
        'sticky top-0 flex max-h-svh min-h-svh w-[268px] flex-col self-start overflow-y-auto',
        'border-r border-white/6 bg-gradient-to-br from-[var(--supev-sidebar-from)] via-indigo-950 to-[var(--supev-sidebar-to)]',
        'px-3.5 py-4 shadow-[4px_0_32px_rgba(15,23,42,0.12)]',
        'max-md:relative max-md:max-h-none max-md:min-h-0 max-md:w-full max-md:border-r-0 max-md:border-b max-md:border-white/8 max-md:shadow-none',
      )}
    >
      <Link
        to="/"
        className="mb-4 block rounded-xl px-2 py-1.5 no-underline transition hover:bg-white/8"
      >
        <strong className="block text-lg tracking-tight text-white">СУП</strong>
        <span className="mt-0.5 block text-xs leading-snug text-slate-400">
          Система управления производством
        </span>
      </Link>

      <nav className="flex flex-1 flex-col gap-0.5 max-md:flex-row max-md:flex-wrap" aria-label="Разделы приложения">
        <NavLink to="/" end className={({ isActive }) => sidebarNavLink(isActive)}>
          Сводка
        </NavLink>
        <NavLink to="/admin/administration" className={({ isActive }) => sidebarNavLink(isActive)}>
          Администрирование
        </NavLink>
        {showProduction && (
          <NavLink to="/production" className={({ isActive }) => sidebarNavLink(isActive)}>
            Продукция и комплектация
          </NavLink>
        )}
        {showProductionRequests && (
          <NavLink to="/production-requests" className={({ isActive }) => sidebarNavLink(isActive)}>
            Заявки на производство
          </NavLink>
        )}
        {showPlanning && (
          <NavLink to="/planning" className={({ isActive }) => sidebarNavLink(isActive)}>
            График производства
          </NavLink>
        )}
        {showInventory && (
          <NavLink to="/inventory" className={({ isActive }) => sidebarNavLink(isActive)}>
            Склад
          </NavLink>
        )}
        {showShipments && (
          <NavLink to="/shipments" className={({ isActive }) => sidebarNavLink(isActive)}>
            Отгрузки
          </NavLink>
        )}
      </nav>

      <div className="mt-auto border-t border-white/10 pt-4">
        <div className="mb-3 flex items-center justify-between gap-2 px-1">
          <NotificationsBell />
        </div>
        <div className="mb-2 px-1">
          <span className="block truncate text-sm font-medium text-white">
            {user?.name || user?.email}
          </span>
          <span className="block text-xs text-slate-400">{user?.roleName}</span>
        </div>
        <button
          type="button"
          className={cn(btn('ghost', 'md'), 'w-full border-white/10 text-slate-300 hover:bg-white/10 hover:text-white')}
          onClick={() => {
            logout()
            navigate('/', { replace: true })
          }}
        >
          Выйти
        </button>
      </div>
    </aside>
  )
}
